import React, { useContext, useEffect, useState } from 'react'
import Navbar from './navbar'
import ShowAuctions from './pages/ShowAuctions'
import { aaplesarkar, barely, barely_black_bg_img, Cidco, cm, dcm, dcmdada, digitalindia, iasgovindraj1, iasgupta1, India, india111, maharashtra, makeinindia, NMMRDA, NMMRDA111, NNgMRDA, NPMRDA, rmmm, uddlogowhite, urbanbanner } from '../../public/LoginImages/importimages'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Homepage = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    vertical: true,
    verticalSwiping: true,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
  };

  return (

    // <div style={{ backgroundImage: `url('${barely_black_bg_img}')`, height: "100vh", width: '100vw', backgroundSize: '100vw 100vh'}}>
    //   <Navbar />
    //   <ShowAuctions/>
    // </div>
    <div >
      <nav className="navbar navbar-dark navbar-expand-md" id="navbar-main" style={{ backgroundColor: "#2f4f4f" }}>
        <div className="container">
          <a href="/" rel="home" className="navbar-brand">
            <img
              src={uddlogowhite}

              className="img-fluid d-inline-block align-top"
            />
          </a>
          <button
            className="navbar-toggler collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#CollapsingNavbar"
            aria-controls="CollapsingNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-end" id="CollapsingNavbar">
            <section className="region region-primary-menu">
              <nav
                role="navigation"
                aria-labelledby="block-bootstrap-barrio-subtheme-main-menu-menu"
                id="block-bootstrap-barrio-subtheme-main-menu"
                className="settings-tray-editable block block-menu navigation menu--main"
                data-drupal-settingstray="editable"
              >
                <h2 className="visually-hidden" id="block-bootstrap-barrio-subtheme-main-menu-menu">
                  Main navigation
                </h2>
                <ul className="clearfix nav navbar-nav " data-component-id="bootstrap_barrio:menu_main" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <li className="nav-item menu-item--expanded dropdown">
                    <a href="/Dashboard/ShowAuctions" style={{ color: '#ccd9cc', textDecoration: 'none' }}>रजिस्ट्रीकरण</a>
                  </li>
                  <li className="nav-item menu-item--expanded dropdown">
                    <span
                      className="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      aria-haspopup="true"
                    >
                      माहिती
                    </span>
                    <ul className="dropdown-menu">
                      <li className="dropdown-item">
                        <a href="/Dashboard/AboutUs" style={{ textDecoration: "none", color: "black" }}>
                          विभागाविषयी
                        </a>
                      </li>
                      <li className="dropdown-item">
                        <a href="/Dashboard/ContactUs" style={{ textDecoration: "none", color: "black" }}>
                          अधिकारी व दूरध्वनी
                        </a>
                      </li>
                    </ul>
                  </li>

                </ul>
              </nav>
            </section>
          </div>
        </div>
      </nav>
      <div
        className="d-flex justify-content-center ">
        <div >
          <p>
            <video className="img-fluid" autoPlay muted loop>
              <source src={urbanbanner} type="video/mp4" />
            </video>
          </p>
        </div>
      </div>
      <div id="main-wrapper" className="layout-main-wrapper clearfix">
        <div id="main" className="container">
          <div className="row row-offcanvas row-offcanvas-left clearfix">
            <main className="main-content col order-first" id="content" role="main">
              <section className="section">
                <a href="#main-content" id="main-content" tabIndex="-1"></a>
                <section className="region region-content">
                  <div id="block-bootstrap-barrio-subtheme-content" className="container block block-system block-system-main-block">
                    <div className="content">
                      <article data-history-node-id="5" lang="en" className="node node--type-page node--view-mode-full clearfix">
                        <header></header>
                        <div className="node__content clearfix">
                          <div className="layout layout--onecol">
                            <div className="layout__region layout__region--content">
                              <div className="block block-layout-builder block-field-blocknodepagebody">
                                <div className="content">
                                  <div className="clearfix text-formatted field field--name-body field--type-text-with-summary field--label-hidden field__item">
                                    <div className="row padded-x">
                                      <div className="col-md-8 p-2">
                                        <div className="row">
                                          <div className="col-3 p-2 text-center">
                                            <img className="img-fluid rounded" src={dcm} alt="देवेंद्र फडणवीस" width="150" height="165" loading="lazy" />
                                            <br /><strong>श्री. देवेंद्र फडणवीस</strong><br />मा. मुख्यमंत्री
                                          </div>
                                          <div className="col-3 p-2 text-center">
                                            <img className="img-fluid rounded" src={cm} alt="एकनाथ शिंदे" width="150" height="165" loading="lazy" />
                                            <br /><strong>श्री. एकनाथ शिंदे</strong><br />मा. उपमुख्यमंत्री
                                          </div>
                                          <div className="col-3 p-2 text-center">
                                            <img className="img-fluid rounded" src={dcmdada} alt="अजीत पवार" width="150" height="165" loading="lazy" />
                                            <br /><strong>श्री. अजीत पवार</strong><br />मा. उपमुख्यमंत्री
                                          </div>
                                          <div className="col-3 p-2 text-center">
                                            <img className="img-fluid rounded" src={rmmm} alt="माधुरी मिसाळ" width="150" height="165" loading="lazy" />
                                            <br /><strong>श्रीमती माधुरी मिसाळ</strong><br />मा. राज्यमंत्री
                                          </div>
                                        </div>
                                        <p class="dropcap">महाराष्ट्र राज्यातील एकूण लोकसंख्येपैकी जवळपास ४८% लोकसंख्या ही नागरी विभागात येतात. नागरी जीवनाशी संबंधीत दैनंदिन प्रश्न देखील दिवसेंदिवस वाढत असून, शहरी भागातील वाहतूक, घरांची समस्या, पाणीपुरवठा, घनकचरा व्यवस्थापन इत्यादी विषय अतिशय महत्त्वाचे झाले आहेत. नगर विकास विभागाच्या नियंत्रणाखालील <a>शहर व औद्योगिक विकास महामंडळ (CIDCO)</a>, <a>नगररचना व मुल्य निर्धारण संचालनालय (DTP)</a>, <a >नगर पालिका प्रशासन संचालनालय (DMA)</a> हे तीन मुख्य विभाग व <a>मुंबई महानगर प्रदेश विकास प्राधिकरण (MMRDA)</a>, <a>पुणे महानगर प्रदेश विकास प्राधिकरण (PMRDA)</a>, <a >नागपूर महानगर प्रदेश विकास प्राधिकरण (NMRDA)</a> आणि <a>नाशिक महानगर प्रदेश विकास प्राधिकरण (NMRDA)</a> अशी ५ प्राधिकरणे येतात.</p>
                                      </div>
                                      <div className="col-md-4 p-2">
                                        <div className="row py-1">
                                          <h4 className="text-center"><strong>प्रशासकीय अधिकारी</strong></h4>
                                          <div>
                                            <img className="img-fluid rounded float-start m-1" src={iasgupta1} alt="IAS Officer" width="100" height="75" loading="lazy" />
                                            <strong>श्री. असीमकुमार गुप्ता</strong><br /><small>मा. अपर मुख्य सचिव</small><br /><small>नगर विकास - १</small>
                                          </div>
                                          <div>
                                            <img className="img-fluid rounded float-start m-1" src={iasgovindraj1} alt="IAS Officer" width="100" height="75" loading="lazy" />
                                            <strong>के एच गोविंदराज</strong><br /><small>मा. प्रधान सचिव</small><br /><small>नगर विकास - २</small>
                                          </div>
                                        </div>
                                        <div className="row border-top border-secondary border-2 pt-3">
                                          <h4 className="text-center col-12"><strong>अधिनस्त कार्यालये!</strong></h4>
                                          <div className="col-4 p-2 text-center">
                                            <a >
                                              <img className="img-fluid rounded" src={maharashtra} alt="DTP" width="250" height="251" loading="lazy" />
                                              <span className="fs-4"><strong>D T P</strong></span>
                                            </a>
                                          </div>
                                          <div className="col-4 p-2 text-center">
                                            <a >
                                              <img className="img-fluid rounded" src={Cidco} alt="CIDCO" width="225" height="225" loading="lazy" />
                                              <span className="fs-4"><strong>C I D C O</strong></span>
                                            </a>
                                          </div>
                                          <div className="col-4 p-2 text-center">
                                            <a >
                                              <img className="img-fluid rounded" src={maharashtra} alt="DMA" width="250" height="251" loading="lazy" />
                                              <span className="fs-4"><strong>D M A</strong></span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </article>
                    </div>
                  </div>
                </section>
              </section>
            </main>
          </div>
        </div>
      </div>
      <div style={{display:'flex',justifyContent:'center',alignItems:'center', width: '99%', backgroundColor: '#ecffec' }}>
        <div class="row p-5">
          <h3 class="text-center"><strong>प्रमुख नगर विकास प्राधिकरण</strong></h3>
          <div class="col-6 col-md-3 p-2 text-center">
            <a ><img class="img-fluid pb-2" src={NMMRDA111} alt="MMRDA" /></a>
            <h5>मुंबई महानगर विकास प्राधिकरण</h5>
          </div>
          <div class="col-6 col-md-3 p-2 text-center">
            <a ><img class="img-fluid pb-2" src={NMMRDA} alt="NMRDA" /></a>
            <h5>नाशिक महानगर विकास प्राधिकरण</h5>
          </div>
          <div class="col-6 col-md-3 p-2 text-center">
            <a ><img class="img-fluid pb-2" src={NNgMRDA} alt="NMRDA" /></a>
            <h5>नागपूर महानगर विकास प्राधिकरण</h5>
          </div>
          <div class="col-6 col-md-3 p-2 text-center">
            <a><img class="img-fluid pb-2" src={NPMRDA} alt="PMRDA" /></a>
            <h5>पुणे महानगर विकास प्राधिकरण</h5>
          </div>
        </div>
      </div>
      <div style={{display:'flex',justifyContent:'center', padding: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-evenly',gap:'2rem',flexWrap:'wrap' }}>
          <div style={{ border: '2px solid darkgray', width: '20rem', height: '19rem', padding: '0px', backgroundColor: '#f8f9fa' }}>
            <div style={{ padding: "8px", backgroundColor: "#f8f9fa" }}>
              <div style={{ textAlign: "center", padding: "8px", backgroundColor: "#2f4f4f", color: "white" }}>
                <h3 >सूचना</h3>
              </div>
              <div className="view-content row" style={{ height: '13rem' }}>
                <Slider {...settings}>
                  <div className="slick__slide" style={{ height: '318p' }}>
                    <p>
                      <a style={{ color: '#2f4f4f' }}>
                        महापालिका व नगरपालिकांचे गाळ्यातील 500 ते 1000 स्क्वे. फू. आकारमानाचा गाळा अल्प भाड्याने मराठी साहित्य विक्रीसाठी देण्याबाबत.
                      </a>
                    </p>
                  </div>
                  <div className="slick__slide" style={{ height: '18rem' }}>
                    <p>
                      <a style={{ color: '#2f4f4f' }}>
                        मौजा पारगांव हद्दीतील कोळी आदिवासीवाडी, ता. पनवेल, जि. रायगड यांच्या पुनर्वसनासाठी भूखंड उपलब्ध करुन देण्याबाबत
                      </a>
                    </p>
                  </div>
                  <div className="slick__slide" style={{ height: '18rem' }}>
                    <p>
                      <a style={{ color: '#2f4f4f' }}>समाजातील स्त्रीभूण हत्येचे प्रमाण रोखण्यासाठी समाजाचे जनजागृती करण्याबरिता नाटयप्रयोगास  उत्तेजन देण्याकरीता विविध स्वयंसेवी संस्थांना…</a></p></div>
                </Slider>
              </div>

            </div>
          </div>

          <div style={{ border: '2px solid darkgray', width: '20rem', height: '19rem', padding: '0px' }}>
            <div style={{ padding: "8px", backgroundColor: "#f8f9fa" }}>
              <div style={{ textAlign: "center", padding: "8px", backgroundColor: "#2f4f4f", color: "white" }}>
                <h3 >अधिनियम/कायदे</h3>
              </div>
              <div className="view-content row" style={{ height: '13rem' }}>
                <Slider {...settings}>
                  <div className="slick__slide" style={{ height: '18rem' }}>
                    <p>
                      <a style={{ color: '#2f4f4f' }}>
                        महाराष्ट्र प्रादेशिक नियोजन व नगररचना अधिनियम,१९६६
                      </a>
                    </p>
                  </div>
                  <div className="slick__slide" style={{ height: '18rem' }}>
                    <p>
                      <a style={{ color: '#2f4f4f' }}>
                        महाराष्ट्र आग प्रतिबंधक व जीवसंरक्षक उपाययोजना अधिनियम,2006
                      </a>
                    </p>
                  </div>
                  <div className="slick__slide" style={{ height: '18rem' }}>
                    <p>
                      <a style={{ color: '#2f4f4f' }}>
                        महाराष्ट्र  नगरपरिषदा, नगरपंचायती व औद्योगिक नगरी अधिनियम, 1965
                      </a>
                    </p>
                  </div> <div className="slick__slide">
                    <p>
                      <a style={{ color: '#2f4f4f' }}>
                        मुंबई महानगरपालिका अधिनियम, 1988
                      </a>
                    </p>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
          <div style={{ border: '2px solid darkgray', width: '20rem', height: '19rem', padding: '0px' }}>
            <div style={{ padding: "8px", backgroundColor: "#f8f9fa" }}>
              <div style={{ textAlign: "center", padding: "8px", backgroundColor: "#2f4f4f", color: "white" }}>
                <h3 >समित्या</h3>
              </div>
              <div className="view-content row" style={{ height: '13rem' }}>
                <Slider {...settings}>
                  <div className="slick__slide" style={{ height: '18rem' }}>
                    <p>
                      <a style={{ color: '#2f4f4f' }}>
                        मुंबई शहारातून वाहणाऱ्या मिठी नदीचा विकास व तिचे संरक्षण करण्यासाठी गठीत झालेले प्राधिकरण
                      </a>
                    </p>
                  </div>
                  <div className="slick__slide" style={{ height: '18rem' }}>
                    <p>
                      <a style={{ color: '#2f4f4f' }}>
                        नवी मुंबई विशेष (मुंबई) आर्थिक क्षेत्राचे नियोजन व विकासाबाबत वेळोवेळी आढावा घेण्यासाठी संनियंत्रण समिती
                      </a>
                    </p>
                  </div>
                  <div className="slick__slide" style={{ height: '18rem' }}>
                    <p>
                      <a
                        style={{ color: '#2f4f4f' }}>
                        पिंपरी- चिंचवड नवनगर विकास प्राधिकरणामार्फत सल्लागार समिती - पूणे आंतरराष्ट्रीय प्रदर्शन व केंद्र, मोशी ( राज्य सल्लागार समिती )                                                </a>
                    </p>
                  </div>
                  <div className="slick__slide" style={{ height: '28rem' }}>
                    <p>
                      <a style={{ color: '#2f4f4f' }}>
                        नाजकधा अधिनियमाच्या सुलभ अंमलबजावणी साठी मंत्रिमंडळ उपसमिती  </a>
                    </p>
                  </div>
                  <div className="slick__slide" style={{ height: '18rem' }}>
                    <p>
                      <a style={{ color: '#2f4f4f' }}>
                        सुकाणू समिती ( दादर चौत्यभूमिचा विकास व सौदर्यीकरण )</a>
                    </p>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <footer style={{ backgroundColor: "#2f4f4f", padding: "20px 0", textAlign: "center" }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <div style={{ display: "flex", justifyContent: "space-around", flexWrap: "wrap", padding: '4rem 0px' }}>
              <section>
                <a href="https://india.gov.in">
                  <img src={india111} alt="India" width="200" height="150" loading="lazy" />
                </a>
              </section>
              <section>
                <a href="https://aaplesarkar.maharashtra.gov.in/">
                  <img src={aaplesarkar} alt="Aaple Sarkar" width="200" height="150" loading="lazy" />
                </a>
              </section>
              <section>
                <a href="https://digitalindia.gov.in/">
                  <img src={digitalindia} alt="Digital India" width="200" height="150" loading="lazy" />
                </a>
              </section>
              <section>
                <a href="https://makeinindia.com">
                  <img src={makeinindia} alt="Make in India" width="200" height="150" loading="lazy" />
                </a>
              </section>
            </div>
            <div style={{ marginTop: "20px", borderTop: "1px solid #ddd", paddingTop: "10px", fontSize: "14px" }}>
              <div style={{ display: "flex", justifyContent: "end", flexWrap: "wrap" }}>
                <div style={{ fontSize: '17px', minWidth: "250px", color: '#fffc' }}>
                  2020 &copy; <a href="https://softmatesystems.com/" style={{ color: '#fffc' }}>All rights reserved by Softmate Systems LLP.</a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  )
}

export default Homepage